var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navbar-item vue-ready__hide",
      class: _vm.stateFacet,
      on: {
        click: _vm.onClick,
        mouseenter: _vm.onHover,
        mouseleave: _vm.onLeave
      }
    },
    [
      _vm.hasChildren
        ? _c(
            "button",
            {
              staticClass:
                "u-reset navbar-item--link navbar-item--link__button",
              attrs: { slot: "label" },
              slot: "label"
            },
            [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
          )
        : _c(
            "a",
            {
              staticClass: "u-reset navbar-item--link",
              attrs: { slot: "label", target: _vm.linkTarget, href: _vm.path },
              slot: "label"
            },
            [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec88965a", { render: render, staticRenderFns: staticRenderFns })
  }
}